import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Alert, Card, CardBody, Button } from "reactstrap";
import LoadingScreen from "react-loading-screen";

import Formulario from "../../../../components/Generales/Formulario";
import { crearAuto, editarAuto } from "../../redux/aZeroAutos";
import { selectAutoSeleccionado, selectIsLoading, selectError } from "../../redux/selectors";

const EditarVehiculo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  const autoSeleccionado = useSelector(selectAutoSeleccionado);
  const isLoading = useSelector(selectIsLoading);
  const apiError = useSelector(selectError);

  const esEdicion = Boolean(id && autoSeleccionado);

  const [values, setValues] = useState({});
  const [loadingForm, setLoadingForm] = useState(true);

  const handleSetValuesInicial = (initialValues) => {
    if (esEdicion && autoSeleccionado) {
      setValues({
        ...initialValues,
        placa: autoSeleccionado.placa || "",
        anio: autoSeleccionado.anio || "",
        propietario: autoSeleccionado.propietario || "",
        // Formato para los select dinámicos {value, label}
        marca: autoSeleccionado.marca ? { value: autoSeleccionado.marca, label: autoSeleccionado.marca } : "",
        modelo: autoSeleccionado.modelo ? { value: autoSeleccionado.modelo, label: autoSeleccionado.modelo } : "",
        color: autoSeleccionado.color ? { value: autoSeleccionado.color, label: autoSeleccionado.color } : ""
      });
    } else {
      setValues(initialValues);
    }
  };

  const handleChange = (key, newValues) => {
    setValues(newValues);
  };

  const handleSubmit = async (formValues, tieneErrores, errores, valuesConTitulo) => {
    if (tieneErrores) {
      console.warn("Hay errores en el formulario dinámico");
      return;
    }

    // Extraer valores crudos para el backend
    const payload = {
      empCodigo: "AIGMETROPOLITANA",
      placa: formValues.placa,
      anio: formValues.anio,
      propietario: formValues.propietario,
      marca: (formValues.marca && formValues.marca.value) ? formValues.marca.value : formValues.marca,
      modelo: (formValues.modelo && formValues.modelo.value) ? formValues.modelo.value : formValues.modelo,
      color: (formValues.color && formValues.color.value) ? formValues.color.value : formValues.color
    };

    let exitoso = false;
    if (esEdicion) {
      exitoso = await dispatch(editarAuto(autoSeleccionado.id, payload));
    } else {
      exitoso = await dispatch(crearAuto(payload));
    }

    if (exitoso) {
      alert(esEdicion ? "Vehículo actualizado" : "Vehículo creado");
      history.push("/zero/vehiculos");
    }
  };

  const handleVolver = () => history.push("/zero/vehiculos");

  return (
    <LoadingScreen
      loading={isLoading || loadingForm}
      bgColor="#ffffff"
      spinnerColor="#007bff"
      textColor="#676767"
      text={loadingForm ? "Configurando formulario..." : "Guardando vehículo..."}
    >
      <div className="container py-4" style={{ maxWidth: "800px" }}>
        <div className="mb-4">
          <Button color="link" onClick={handleVolver} className="p-0 text-muted d-inline-flex align-items-center">
            Volver al listado
          </Button>
          <h1 className="h3 mt-2 font-weight-bold text-gray-800">
            {esEdicion ? "Editar Vehículo (Formulario Dinámico)" : "Nuevo Vehículo (Formulario Dinámico)"}
          </h1>
        </div>

        {apiError && <Alert color="danger">Error: {apiError}</Alert>}

        <Card className="shadow-sm border-0">
          <CardBody>
            <Formulario
              codigoFormulario="formulario-vehiculos-test"
              onSubmit={handleSubmit}
              onChange={handleChange}
              values={values}
              setValuesInicial={handleSetValuesInicial}
              setLoading={setLoadingForm}
              anchoPagina={12}
              esRenovacion={false}
            />
          </CardBody>
        </Card>
      </div>
    </LoadingScreen>
  );
};

export default EditarVehiculo;
